export const AuthSkipCountries = {
    ads: [],
    verticals: [],
    abTest: ['fi', 'no', 'dk'],
    adsBundleVersion: [],
    cache: ['fi', 'no', 'dk'],
}